/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
export const S = {
    containerStyle: {
        // border: "1px solid rgba(0,0,0,0.2)",
        minHeight: '8em',
        cursor: 'text',
        borderRadius: '10px',
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
        marginLeft: '10px',
        marginRight: '10px',
        marginBottom: '5px',
    },
};
